import {MdThumbUp, MdThumbUpOffAlt} from 'react-icons/md';

type Props = {
  isLiked: boolean;
  likedCount: number;
  handleLiked: () => void;
};

export const LikeButton: React.FC<Props> = ({
  isLiked,
  likedCount,
  handleLiked,
}) => {
  return (
    <button
      className="flex items-center pc:hover:opacity-80 pc:hover:duration-300 pc:hover:ease-in-out"
      onClick={handleLiked}
    >
      {isLiked ? (
        <MdThumbUp size="20" fill="#EDB835" />
      ) : (
        <MdThumbUpOffAlt size="20" fill="#A0A0A0" />
      )}
      <span className="pl-[6px] text-xs leading text-black-2">
        {likedCount}
      </span>
    </button>
  );
};
